import React, { useContext, useMemo } from 'react';
import { useStyletron } from 'baseui';
import { DataList, CustomModal } from 'commons-ui';

import { LIST_ENTITY_NAMES } from 'constant';
import { UserDetailsContext } from 'context/userDetails';
import useKycBankNameMismatch from './useKycBankNameMismatch';
import { ApproveContext } from './approveContext';
import { columnConfigs } from './list/listConfig';
import { PAGE_SIZE } from './constants';

/**
 * The selected user's latest KYC rejection raised by the DigiLocker bank-name match.
 *
 * One row at most: the newest attempt inside the ZK-configured window. Approving any row approves
 * the user and clears their other flagged rejections, so older attempts are not worth offering.
 */
const KycBankNameMismatch: React.FC<{}> = () => {
	const {
		selectedUser: { uid }
	} = useContext(UserDetailsContext);
	const { fetchData, forceUpdate, turnGlobalForceUpdateOff, refresh, canApprove, lookbackDays } = useKycBankNameMismatch();
	const [css] = useStyletron();
	const approveContextValue = useMemo(() => ({ refresh, canApprove }), [refresh, canApprove]);

	return (
		<ApproveContext.Provider value={approveContextValue}>
			<div
				className={css({
					minHeight: '60px',
					display: 'flex',
					alignItems: 'center',
					backgroundColor: 'white',
					paddingLeft: '10px',
					borderTop: '1px solid rgb(242, 242, 242)'
				})}>
				<span>
					Latest bank-name-mismatch KYC rejection for user {uid}
					{lookbackDays ? ` (last ${lookbackDays} day${lookbackDays === 1 ? '' : 's'})` : ''}
				</span>
			</div>
			<DataList
				fetchData={fetchData}
				columnConfigs={columnConfigs}
				hideActions
				rowHeight={50}
				entity={LIST_ENTITY_NAMES.KYC_BANK_NAME_MISMATCH}
				globalForceUpdate={forceUpdate}
				turnGlobalForceUpdateOff={turnGlobalForceUpdateOff}
				height='calc(100vh - 220px)'
				filterable={false}
				searchable={false}
				// At most one row arrives; DataList's default page size is 5000.
				defaults={{ pageDetails: { pageNo: 1, pageSize: PAGE_SIZE } }}
			/>
			<CustomModal />
		</ApproveContext.Provider>
	);
};

export default KycBankNameMismatch;
